let ORCHESTRATION_ERRORS_TAB = {
  options: {
    tabName: 'orchestrationErrors',
    uri: '/orchestrationErrors'
  },
  columns: [{
    name: 'errorText',
    label: 'Issue',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  }, {
    name: 'type',
    label: 'Object ',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  }, {
    name: 'id',
    label: 'Sourced Id',
    type: 'table-grid-text-cell'
  }]
};

export
default ORCHESTRATION_ERRORS_TAB;



// WEBPACK FOOTER //
// ./app/models/orchestrationErrorTab.js